import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { LessonVersionOwnerInputs } from 'frontend/types/lessons/requests';
import { apiResolve } from 'frontend/router';
import { apiRequestWithErrors } from 'frontend/store/modules/lessons/apiHelpers';

interface LessonOwnerState {
  ownerFirstName: string;
  ownerFullName: string;
  lastModifiedTs: string;
  errors: string[];
  isReloading: boolean;
}

const lessonOwner: Module<LessonOwnerState, RootState> = {
  namespaced: true,
  state: {
    ownerFirstName: '',
    ownerFullName: '',
    lastModifiedTs: '',
    errors: [],
    isReloading: false,
  },

  mutations: {
    setValue(state: LessonOwnerState, newState: Partial<LessonOwnerState>) {
      state.ownerFirstName = newState.ownerFirstName || '';
      state.ownerFullName = newState.ownerFullName || '';
      state.lastModifiedTs = newState.lastModifiedTs || '';
    },
    setErrors(state: LessonOwnerState, errors: string[]) {
      state.errors = errors;
    },
    setReloading(state: LessonOwnerState) {
      state.isReloading = true;
    },
  },

  actions: {
    async fetchOwnerDetails({ commit }, { formData }: LessonVersionOwnerInputs): Promise<void> {
      commit('setErrors', []);
      const route = apiResolve({ name: 'lesson_owner_details' });
      const [_, results, errors] = await apiRequestWithErrors(route.href, formData);
      const ownerData = results?.lesson_version_owner;

      if (errors.length) {
        commit('setErrors', errors);
      }

      if (ownerData) {
        const newState: Partial<LessonOwnerState> = {
          ownerFirstName: ownerData.owner_first_name,
          ownerFullName: ownerData.owner_full_name,
          lastModifiedTs: ownerData.last_modified_ts,
        };
        commit('setValue', newState);
      } else {
        commit('setErrors', ['Something went wrong when fetching owner details.']);
      }
    },

    clearDetails({ commit }) {
      commit('setValue', {});
    },

    async takeOwnership({ commit }, { formData }: LessonVersionOwnerInputs): Promise<void> {
      commit('setErrors', []);
      const route = apiResolve({ name: 'lesson_owner_take_ownership' });
      const [success, _, errors] = await apiRequestWithErrors(route.href, formData);

      if (success) {
        window.location.reload();
        commit('setReloading');
      } else if (errors.length) {
        commit('setErrors', errors);
      } else {
        commit('setErrors', ['Something went wrong when taking ownership of this lesson.']);
      }
    },
  },
};

export default lessonOwner;
